export const getChannels = (dataSourceHandles, returnValue) => {
  let channels = [];

  dataSourceHandles.forEach((dataSourceHandle) => {
    const { trendsId, name } = dataSourceHandle;
    if (returnValue === "ids") {
      channels.push(trendsId);
    } else {
      let dataSource = {
        value: trendsId,
        name: name,
      };
      channels.push(dataSource);
    }
  });

  return channels;
};

export function removeIdTag(str) {
  return str.replace(/\s*\(#?\d+\)/, "");
}
